import RateCardTableItemList, { RateCardTableItemListProps } from './RateCardTableItemList';

export type { RateCardTableItemListProps };
export default RateCardTableItemList;
